import { render, staticRenderFns } from "./AdministrationChat.vue?vue&type=template&id=67e7e2bb&"
import script from "./AdministrationChat.vue?vue&type=script&lang=js&"
export * from "./AdministrationChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports